import {jsonSafeGet} from "utils/Helpers";
import {AuthV2Type} from "dataLayer/localStorage/localStorageMember";
import {CookiesConstants} from "utils/constants";
import {parseCookies, setCookie} from "utils/nookies";
import {resetClickStreamSearchID, resetClickStreamSearchSource} from "../libs/clickstream/helpers/clickStreamHelpers";
import {uuidv4} from "@firebase/util";


export default async function  useGenerateSession (device_uuid) {


            const cookies = parseCookies();
            // // generate session cookie
            const deviceUUID = jsonSafeGet<AuthV2Type>(cookies[CookiesConstants.AUTH_V2])?.deviceUUID || device_uuid;
            let sessionId = jsonSafeGet<any>(cookies[CookiesConstants.SESSION], {})?.id;
            let sessionStartedAt = Number(jsonSafeGet<any>(cookies[CookiesConstants.SESSION], {})?.startedAt)
            if (!sessionId) {
                const trackingId = deviceUUID;
                let sessionIdPrefix = typeof trackingId == "string" ? trackingId.slice(0, trackingId.length * 0.5).replace("-", "") : trackingId + "-";
                sessionId = sessionId = sessionIdPrefix + uuidv4();
                sessionStartedAt = new Date().getTime();
            }

            if (sessionId){
                setCookie(null, CookiesConstants.SESSION, JSON.stringify({
                    id: sessionId,
                    startedAt: sessionStartedAt,
                }))
            } else {
                setCookie(null, CookiesConstants.SESSION, JSON.stringify({
                    id: null,
                    startedAt: null,
                }))
                resetClickStreamSearchID()
                resetClickStreamSearchSource()
                sessionId = null;
            }
};
